import { render, staticRenderFns } from "./NewFeedEntry.vue?vue&type=template&id=8a8ee53e&scoped=true"
import script from "./NewFeedEntry.vue?vue&type=script&lang=js"
export * from "./NewFeedEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ee53e",
  null
  
)

export default component.exports